import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const ELExercise: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<path
				d="m7.5289 6.1569c-1.086 0.023483-1.0849 0.02087-1.5755 0.97102l-3.3246 6.6042v0.0019h4.2141l2.11-4.2811h8.5522l2.11 4.2811h4.2141v-0.0019l-3.3246-6.6042c-0.49067-0.95015-0.48954-0.94754-1.5755-0.97102h-6.7002z"
				fillRule="evenodd"
			/>
			<path
				d="m2.6303 13.726c-1.427e-4 0.0085-0.0015 0.01655-0.0015 0.02501v4.5231c0 0.80332 0.64672 1.45 1.45 1.45h18.3c0.80332 0 1.45-0.64672 1.45-1.45v-4.5231c0-0.0085-0.0014-0.01658-0.0015-0.02501h-7.8582a2.8462 2.8462 0 0 1-2.7406 2.089 2.8462 2.8462 0 0 1-2.7436-2.089z"
				fillRule="evenodd"
			/>
		</SvgIcon>
	);
};

export default ELExercise;



// WEBPACK FOOTER //
// ./src/icons/ELExercise.tsx